import { bindView } from './bindings.js';
import { fmtDM, today } from './dates.js';
import { t } from './i18n/index.js';
import { groupLabel, invStatus, meetOf, sesEnd, settlePackages, stu, stuInitials } from './model.js';
import { S } from './state.js';
import { vCalendar } from './views/calendar.js';
import { vHome } from './views/home.js';
import { vInvoices } from './views/invoices.js';
import { vSettings } from './views/settings.js';
import { vContact } from './views/contact.js';
import { updateTrialUI } from './cloud/plan.js';
import { teacherAvatar, vTeam } from './views/team.js';
import { isMine, schoolView, teacherOf } from './team/team.js';
import { applyRoleFlags } from './team/team.js';
import { vStats } from './views/stats.js';
import { vParents } from './views/parents.js';
import { vStudent, vStudents } from './views/students.js';

export const $=s=>document.querySelector(s);
export const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
export const IC={
  plus:'<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>',
  video:'<svg viewBox="0 0 24 24"><rect x="3" y="6.5" width="12.5" height="11" rx="2.5"/><path d="m15.5 10.5 5-2.8v8.6l-5-2.8"/></svg>',
  play:'<svg viewBox="0 0 24 24"><path d="M7 4.8v14.4L19 12z"/></svg>',
  wa:'<svg viewBox="0 0 24 24"><path d="M12 3.5a8.5 8.5 0 0 0-7.3 12.8L3.5 20.5l4.4-1.15A8.5 8.5 0 1 0 12 3.5z"/><path d="M8.8 9.2c.2-.8.7-.9 1.1-.9l.6.03c.2 0 .4 0 .6.5l.8 1.9c.06.2.1.4-.05.6l-.5.6c-.13.2-.16.3-.03.55.5.9 1.5 1.8 2.5 2.2.25.1.4.08.55-.1l.7-.75c.2-.2.4-.15.6-.07l1.8.9c.3.15.4.25.4.5-.02.5-.35 1.6-1.6 1.85-1 .2-2.3-.1-3.9-1.1-1.9-1.2-3-2.9-3.4-3.8-.4-.9-.5-1.9-.2-2.9z"/></svg>',
  mail:'<svg viewBox="0 0 24 24"><rect x="3" y="5.5" width="18" height="13" rx="2.5"/><path d="m4 7.5 8 6 8-6"/></svg>',
  cal:'<svg viewBox="0 0 24 24"><rect x="3.5" y="5" width="17" height="15.5" rx="2.5"/><path d="M3.5 9.5h17M8 3v4M16 3v4"/></svg>',
  doc:'<svg viewBox="0 0 24 24"><path d="M6.5 3.5h7L18.5 8v12.5h-12z"/><path d="M13 3.5V8h4.8M9 12.5h6M9 16h6"/></svg>',
  check:'<svg viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
  x:'<svg viewBox="0 0 24 24"><path d="m6 6 12 12M18 6 6 18"/></svg>',
  edit:'<svg viewBox="0 0 24 24"><path d="M4 20h4.5L20 8.5 15.5 4 4 15.5z"/><path d="m13.5 6 4.5 4.5"/></svg>',
  trash:'<svg viewBox="0 0 24 24"><path d="M5 7h14M9.5 7V4.5h5V7M7 7l1 13h8l1-13M10 11v6M14 11v6"/></svg>',
  copy:'<svg viewBox="0 0 24 24"><rect x="8.5" y="8.5" width="12" height="12" rx="2.5"/><path d="M5.5 15.5h-1a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"/></svg>',
  left:'<svg viewBox="0 0 24 24"><path d="m14.5 6-6 6 6 6"/></svg>',
  right:'<svg viewBox="0 0 24 24"><path d="m9.5 6 6 6-6 6"/></svg>',
  dl:'<svg viewBox="0 0 24 24"><path d="M12 4v11M7 10.5l5 5 5-5M4.5 20h15"/></svg>',
  clock:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2.5"/></svg>',
  bolt:'<svg viewBox="0 0 24 24"><path d="M13 3 5 13.5h5.5L11 21l8-10.5h-5.5z"/></svg>',
  print:'<svg viewBox="0 0 24 24"><path d="M7 8V4h10v4M7 17H4.5v-7h15v7H17"/><path d="M7 14.5h10V20H7z"/></svg>',
  chat:'<svg viewBox="0 0 24 24"><path d="M21 11.5a8.5 8.5 0 0 1-8.5 8.5c-1.2 0-2.35-.25-3.4-.7L3.5 20.5l1.2-4.3A8.5 8.5 0 1 1 21 11.5z"/></svg>',
  cloud:'<svg viewBox="0 0 24 24"><path d="M17.5 18.5h-11a4 4 0 0 1-.6-7.95A5.5 5.5 0 0 1 16.6 8.6a4.5 4.5 0 0 1 .9 9.9z"/></svg>',
  eye:'<svg viewBox="0 0 24 24"><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/></svg>',
  user:'<svg viewBox="0 0 24 24"><circle cx="12" cy="8.5" r="3.8"/><path d="M4.5 20c.8-4 3.9-6 7.5-6s6.7 2 7.5 6"/></svg>',
  share:'<svg viewBox="0 0 24 24"><path d="M12 3.5v11M8 7l4-3.5L16 7"/><path d="M5 12.5v6a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-6"/></svg>',
  shield:'<svg viewBox="0 0 24 24"><path d="M12 3.5 5 6v6c0 4.2 2.8 7.5 7 8.5 4.2-1 7-4.3 7-8.5V6z"/><path d="m9 12 2 2 4-4"/></svg>'
};
/* the open page survives a reload (pull-to-refresh, the phone reloading a backgrounded app) */
const VIEWS=['home','calendar','students','student','invoices','stats','settings','contact','team','parents'];
export const RT=(()=>{try{const r=JSON.parse(sessionStorage.getItem('plume.route')||'null');if(r&&VIEWS.includes(r.v))return{v:r.v,id:r.id||null}}catch(e){}return{v:'home',id:null}})();
/* calendar view: the month/week choice is remembered on this device; the shown week/month survives
   an app restart the same day (the phone often reloads a backgrounded app) */
export const CAL=(()=>{
  let mode='month',anchor=today();
  try{const m=localStorage.getItem('plume.calMode');if(m==='week'||m==='month')mode=m}catch(e){}
  try{const a=JSON.parse(sessionStorage.getItem('plume.calAnchor')||'null');if(a&&a.on===today()&&/^\d{4}-\d{2}-\d{2}$/.test(a.d))anchor=a.d}catch(e){}
  const c={};
  Object.defineProperty(c,'mode',{enumerable:true,get:()=>mode,set:v=>{mode=v==='week'?'week':'month';try{localStorage.setItem('plume.calMode',mode)}catch(e){}}});
  Object.defineProperty(c,'anchor',{enumerable:true,get:()=>anchor,set:v=>{anchor=v;try{sessionStorage.setItem('plume.calAnchor',JSON.stringify({d:v,on:today()}))}catch(e){}}});
  return c;
})();

export function toast(msg){const d=document.createElement('div');d.className='toast';d.textContent=msg;$('#toasts').appendChild(d);setTimeout(()=>{d.style.opacity='0';d.style.transition='opacity .3s';setTimeout(()=>d.remove(),320)},2600)}

/* ---------- sheets ---------- */
export let sheetStack=[];
export function sheet(html,cls){
  const back=document.createElement('div');back.className='sheetback';
  back.innerHTML='<div class="sheet '+(cls||'')+'" role="dialog">'+html+'</div>';
  $('#sheetroot').appendChild(back);
  requestAnimationFrame(()=>back.classList.add('show'));
  back.addEventListener('click',e=>{if(e.target===back)closeSheet(back)});
  sheetStack.push(back);
  return back;
}
export function closeSheet(back){
  back=back||sheetStack[sheetStack.length-1];if(!back)return;
  sheetStack=sheetStack.filter(b=>b!==back);
  back.classList.remove('show');setTimeout(()=>back.remove(),240);
}
export function closeAllSheets(){[...sheetStack].forEach(b=>closeSheet(b))}
export function ask(msg,onYes,danger){
  const b=sheet('<div class="sheetbody" style="padding-top:22px"><p style="font-size:15px;line-height:1.55">'+esc(msg)+'</p></div><div class="sheetfoot"><button class="btn" data-a="no">'+t('c.cancel')+'</button><button class="btn '+(danger?'danger':'primary')+'" data-a="yes">'+t('c.confirm')+'</button></div>');
  b.querySelector('[data-a=no]').onclick=()=>closeSheet(b);
  b.querySelector('[data-a=yes]').onclick=()=>{closeSheet(b);onYes&&onYes()};
}

/* ---------- nav / render ---------- */
export function nav(v,id){RT.v=v;RT.id=id||null;try{sessionStorage.setItem('plume.route',JSON.stringify({v,id:RT.id}))}catch(e){}render();window.scrollTo({top:0})}
let SHOWN=null;
export function render(){
  document.documentElement.lang=S.settings.lang;
  document.documentElement.dataset.view=RT.v;
  try{updateTrialUI()}catch(e){}
  try{applyRoleFlags()}catch(e){}
  document.querySelectorAll('[data-nav]').forEach(b=>b.classList.toggle('on',b.dataset.nav===RT.v||(RT.v==='student'&&b.dataset.nav==='students')));
  document.querySelectorAll('[data-t]').forEach(el=>el.textContent=t(el.dataset.t));
  $('#wm-sub').textContent=t('app.tag');
  document.querySelectorAll('[data-lang-toggle]').forEach(b=>b.textContent=(S.settings.lang||'en').toUpperCase());
  try{settlePackages()}catch(e){console.warn('packages',e)}
  const m=$('#view');
  const V={home:vHome,calendar:vCalendar,students:vStudents,student:vStudent,invoices:vInvoices,stats:vStats,settings:vSettings,contact:vContact,team:vTeam,parents:vParents};
  m.innerHTML=(V[RT.v]||vHome)();
  bindView(m);
  let anim=[...m.children].filter(el=>!el.matches('.homegrid,.twocol,.grid2,.statgrid'));
  m.querySelectorAll('.homegrid>div,.twocol>div,.grid2>div').forEach(col=>anim.push(...col.children));
  m.querySelectorAll('.statgrid').forEach(sg=>anim.push(...sg.children));
  const fresh=SHOWN!==RT.v;SHOWN=RT.v;
  if(fresh&&!document.body.classList.contains('booting'))anim.forEach((el,i)=>{el.classList.add('ain');el.style.setProperty('--i',Math.min(i,14))});
}

/* ---------- shared bits ---------- */
export function avatarHtml(s,cls){return '<div class="avatar '+(cls||'')+'" style="background:'+s.color+'">'+esc(stuInitials(s))+'</div>'}
export function statusChip(st){
  const map={planned:['blue',t('ses.planned')],done:['ok',t('ses.done')],cancelled:['',t('ses.cancelled')],noshow:['warn',t('ses.noshow')]};
  const[m,l]=map[st]||['',st];return '<span class="chip '+m+'">'+l+'</span>';
}
export function invChip(i){
  const st=invStatus(i);
  const map={scheduled:['sched',t('inv.scheduled')+' · '+fmtDM(i.issue)],draft:['',t('inv.draft')],sent:['blue',t('inv.sent')],paid:['ok',t('inv.paid')],overdue:['red',t('inv.overdue')],cancelled:['',t('inv.cancelled')]};
  const[m,l]=map[st];return '<span class="chip '+m+'">'+l+'</span>';
}
/* a group lesson in a list: stacked avatars, the group's name, how many */
function grpLine(e,showDate){
  const ss=e.members.map(m=>stu(m.studentId)).filter(Boolean);
  const ghost=e.status==='cancelled';
  return '<div class="listrow click" data-evt="'+e.id+'"><div class="avstack">'+ss.slice(0,3).map(x=>avatarHtml(x)).join('')+'</div>'+
    '<div class="grow"><div class="title" style="'+(ghost?'opacity:.55;text-decoration:line-through':'')+'">'+esc(groupLabel(e.members))+' <span class="chip" style="padding:1px 7px">'+esc(t('grp.n',{n:ss.length}))+'</span>'+(e.recId?' <span class="chip" style="padding:1px 7px" title="'+t('cal.series')+'">↻</span>':'')+'</div>'+
    '<div class="meta">'+(showDate?fmtDM(e.date)+' · ':'')+e.time+'–'+sesEnd(e)+' · '+e.dur+' '+t('c.min')+'</div></div>'+
    (meetOf(e)?'<button class="iconbtn" data-meet="'+esc(meetOf(e))+'" title="'+esc(t('ev.join'))+'">'+IC.video+'</button>':'')+'</div>';
}
export function evtLine(e,showDate){
  if(e.members&&e.members.length>1)return grpLine(e,showDate);
  const s=stu(e.studentId);if(!s)return '';
  const ghost=e.status==='cancelled'||e.status==='noshow';
  return '<div class="listrow click" data-evt="'+e.id+'">'+avatarHtml(s)+
    '<div class="grow"><div class="title" style="'+(ghost?'opacity:.55;text-decoration:line-through':'')+'">'+esc(s.first+' '+(s.last||''))+
    (s.level?' <span class="pill-lang">'+esc(s.level)+'</span>':'')+(e.recId?' <span class="chip" style="padding:1px 7px" title="'+t('cal.series')+'">↻</span>':'')+'</div>'+
    '<div class="meta">'+(showDate?fmtDM(e.date)+' · ':'')+e.time+'–'+sesEnd(e)+' · '+e.dur+' '+t('c.min')+(e.status!=='planned'?' · '+({done:t('ses.done'),cancelled:t('ses.cancelled'),noshow:t('ses.noshow')}[e.status]||''):'')+'</div></div>'+
    (schoolView()?teacherAvatar(teacherOf(e)):'')+
    (meetOf(e)?'<button class="iconbtn" data-meet="'+esc(meetOf(e))+'" title="'+esc(t('ev.join'))+'">'+IC.video+'</button>':'')+
    (e.status==='planned'&&e.date===today()&&(!schoolView()||isMine(e))?'<button class="btn small primary" data-start="'+e.id+'">'+IC.play+' '+t('home.startLesson')+'</button>':'')+
    '</div>';
}

/* ================= HOME ================= */
